module.exports = __webpack_public_path__ + "static/bano-3b386fa1af1cd2e208a6973c166d4e8c.jpg";